import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Icon from '../../Icon';
import SVGCheckbox from './SVGCheckbox';
import { isFlagler } from '../../../constants/brandConfig';
import { isLoggedInSelector } from '../../../redux/auth/selectors';
import styles from './index.styl';

const Checkbox = ({
  id,
  label,
  labelStyle,
  name,
  checked,
  disabled,
  value,
  children,
  size,
  style,
  onChange,
  isLoggedIn,
  className,
}) => {
  const isLoggedFlagler = isFlagler && !isLoggedIn;

  return (
    <label htmlFor={id} styleName="input" style={style} className={className}>
      <input
        type="checkbox"
        disabled={disabled}
        checked={checked}
        value={value}
        id={id}
        name={name}
        onChange={e => onChange(e.target.checked)}
      />
      {!isLoggedFlagler && (
        <div styleName="checker">
          <SVGCheckbox size={size} />
          <SVGCheckbox size={size} checked />
        </div>
      )}
      {isLoggedFlagler && (
        <div styleName="checker">
          {checked && <Icon name="blue_checkbox_checked" size={16} />}
          {!checked && <Icon name="blue_checkbox_unchecked" size={16} />}
        </div>
      )}
      <If condition={label}>
        <span styleName="label" style={labelStyle}>
          {label}
        </span>
      </If>
      {children}
    </label>
  );
};

Checkbox.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  labelStyle: PropTypes.object,
  style: PropTypes.object,
  size: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.number,
    PropTypes.string,
  ]),
  isLoggedIn: PropTypes.bool,
  className: PropTypes.string,
};

Checkbox.defaultProps = {
  checked: false,
  onChange: () => {},
  size: 12,
};

const mapStateToProps = state => ({
  isLoggedIn: isLoggedInSelector(state),
});

export default compose(
  connect(mapStateToProps),
  CSSModules(styles, { allowMultiple: true }),
)(Checkbox);



// WEBPACK FOOTER //
// ./src/components/common/Checkbox/index.jsx